namespace Areas.Finance.Memos {
    "use strict";

    let projectNumber: string;
    let projectName: string;
    let projectId: number;



    export function viewLink(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.accountId; },
            "<a href= '/Account/Profile/View/{placeholder}'>View</a>");
    }

    export function addMemo() {

        const glGrid = $("#MemosGrid").dxDataGrid("instance");

        const parameters = {
            projectName: projectName,
            projectNumber: projectNumber,
            projectId: projectId,
            calledFrom: "Memos"
        };


        const createGLMemoDialog = new Areas.Dialogs.GLMemo.CreateGLMemoDialog(memoDialogClosing, parameters)
    }

    export function editMemo() {
        const glGrid = $("#MemosGrid").dxDataGrid("instance");
        const selectedRows = glGrid.getSelectedRowsData();

        if (selectedRows.length) {

            const parameters = {
                data: selectedRows[0],
                calledFrom: "Memos"
            };

            const editGLMemoDialog = new Areas.Dialogs.GLMemo.EditGLMemoDialog(memoDialogClosing, parameters);

        }
    }

    function memoDialogClosing() {
            Areas.refreshGrid("MemosGrid");
      
    }




}
